<template lang="pug">
	modal
		.card.text-left
			.card-header
				span Localidades
				button.close(@click="cerrar") &times;
			table.table.table-striped
				thead
					tr
						th #
						th Fila
						th Asiento
						th Nombre
						th Comentarios
						th
							span.fa.fa-trash
				tbody
					tr(
						v-for="(localidad, l) in invitado.Localidades"
						:class="!localidad.Fila || !localidad.Asiento ? 'incompleta' : ''"
					)
						td.p-1 {{l + 1}}
						td.p-1
							input.form-control.form-control-sm(v-model="invitado.Localidades[l].Fila", size="5" :disabled="true")
						td.p-1
							input.form-control.form-control-sm(v-model="invitado.Localidades[l].Asiento", size="5" :disabled="true")
						td.p-1
							input.form-control.form-control-sm(v-model="invitado.Localidades[l].Nombre", placeholder="Opcional")
						td.p-1
							input.form-control.form-control-sm(v-model="invitado.Localidades[l].Comentarios", placeholder="Opcional")
						td.p-1
							button.btn.btn-sm.btn-danger(@click="borrar(l)")
								span.fa.fa-trash
			.card-body.bg-danger.text-white(v-if="duplicados")
				span.fa.fa-exclamation-triangle.mr-2
				| Hay {{duplicados}} asientos asignados a personas diferentes
			.card-footer
				.row
					.col
						button.btn.btn-warning.btn-sm(@click="mostrarRecinto = true")
							span.fa.fa-eye.mr-2
							| En el mapa
					.col.text-right
						button.btn.btn-sm.btn-primary(@click="cerrar")
							span.fa.fa-check.mr-2
							| Confirmar
		VerRecinto(
			:EventoID="invitado.EventoID",
			:objetivo="invitado.Localidades.length",
			:asientos="invitado.Localidades",
			@cerrar="mostrarRecinto = false",
			v-if="mostrarRecinto",
			@confirmar="aplicarLocalizaciones($event)"
		)
</template>

<script>
import VerRecinto from './verRecinto'
export default {
	props: ['invitado', 'EventoID'],
	components: {
		VerRecinto
	},
	data () {
		return {
			mostrarRecinto: false
		}
	},
	computed: {
		duplicados () {
			const mapa = new Map()
			return this.invitado.Localidades.reduce((acum, actual, l) => {
				if (actual.Fila && actual.Asiento) {
					const cadena = actual.Fila + '-' + actual.Asiento
					if (mapa.has(cadena)) {
						acum++
					} else {
						mapa.set(cadena, true)
					}
				}
				return acum
			}, 0)
		}
	},
	methods: {
		aplicarLocalizaciones (datos) {
			datos.sort((a, b) => {
				if (a.Fila > b.Fila) {
					return 1
				} else if (a.Fila < b.Fila) {
					return -1
				} else {
					if (a.Asiento > b.Asiento) {
						return 1
					} else if (a.Asiento < b.Asiento) {
						return -1
					} else {
						return 0
					}
				}
			})

			for (let i = 0; i < this.invitado.Localidades.length; i++) {
				this.invitado.Localidades[i].Fila = datos[i].Fila
				this.invitado.Localidades[i].Asiento = datos[i].Asiento
			}
		},
		borrar (l) {
			this.invitado.Localidades[l].Fila = null
			this.invitado.Localidades[l].Asiento = null
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
tr.incompleta > td > input {
	border: 1px solid darkred;
}
</style>


// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/components/editor/localidades.vue